import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { ConfigStore, DepartmentsStore, DictionariesStore } from './core/stores';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly dictionariesStore = inject(DictionariesStore);
  private readonly departmentsStore = inject(DepartmentsStore);
  private readonly configStore = inject(ConfigStore);
  private readonly matIconRegistry = inject(MatIconRegistry);

  ngOnInit(): void {
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    this.dictionariesStore.load();
    this.configStore.load();
    this.departmentsStore.load();
  }
}
